import { render, staticRenderFns } from "./Info-stat-card-12-month-comparison.vue?vue&type=template&id=5c4827d5&scoped=true&"
import script from "./Info-stat-card-12-month-comparison.vue?vue&type=script&lang=js&"
export * from "./Info-stat-card-12-month-comparison.vue?vue&type=script&lang=js&"
import style0 from "./Info-stat-card-12-month-comparison.vue?vue&type=style&index=0&id=5c4827d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4827d5",
  null
  
)

export default component.exports